var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "frame-sequence" }, [_c('div', { directives: [{ name: "loading", rawName: "v-loading", value: _vm.loading, expression: "loading" }], staticClass: "frame-sequence-container", style: _vm.frameSequenceContainerStyle }, [this.initKeyFramesOnMounted ? _c('div', { ref: "frame-sequence", style: { width: _vm.width, height: _vm.height } }) : _c('img', { attrs: { "src": _vm.images[0] } })]), _vm._v(" "), _vm._t("default")], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };